<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useToastStore } from '@/plugins/toast/toastStore'
import ToastComponent from './ToastComponent.vue'

const toastStore = useToastStore()
const { current } = storeToRefs(toastStore)
const { next } = toastStore

const opened = computed(() => !!current.value)
</script>
<template>
    <ToastComponent
        v-if="current"
        :model-value="opened"
        :toast="current"
        @closed="next(true)"
    />
</template>
